import { reactQueryGet } from "@circle-react/helpers/backendRequestHelpers";
import { internalApi } from "@circle-react/helpers/urlHelpers";
import { createQueryKeyFactory } from "@circle-react/lib/queries/createQueryKeyFactory";
import { queryOptions } from "react-query";

// Mobile-web-only - see InternalApi::BrandedMobileApps::HomeTabsCustomNamesController.
// Narrowed to known consumers (just "spaces" today) so a typo'd key fails to
// compile instead of silently falling back to the default translation at runtime.
type HomeTabsCustomNames = Partial<Record<"spaces", string>>;

export const homeTabsCustomNameKey = createQueryKeyFactory(
  "home-tabs-custom-name",
);

interface ForMemberParams {
  communityId?: number;
  communityMemberId?: number;
}

export const homeTabsCustomNameQueries = {
  forMember: ({ communityId, communityMemberId }: ForMemberParams) =>
    queryOptions({
      // Member ID included in case two members with different access-group
      // visibility share a browser session.
      queryKey: homeTabsCustomNameKey.key(
        communityId ?? "disabled",
        communityMemberId ?? "disabled",
      ),
      queryFn: () =>
        reactQueryGet<HomeTabsCustomNames>(
          internalApi.communities.homeTabsCustomNames.show(),
        ),
      enabled: Boolean(communityId && communityMemberId),
      // An admin rename should show up on the member's next visit without
      // requiring a hard refresh - 5 min is enough to avoid re-fetching on
      // every tab switch while still catching same-session renames reasonably
      // soon.
      staleTime: 5 * 60 * 1000,
    }),
};
